import { useEffect, useState } from 'react';

export default function ScrollArrow() {
  // Add this state variable at the start of your component
  const [isHalfwayScrolled, setIsHalfwayScrolled] = useState(false);

  // Add this effect to update isHalfwayScrolled when the page is scrolled
  useEffect(() => {
    const handleScroll = () => {
      const halfwayPoint = document.body.scrollHeight / 2;
      setIsHalfwayScrolled(window.scrollY >= halfwayPoint);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed bottom-6 right-7 flex flex-col items-center space-y-4">
      <button
        onClick={() => window.scrollTo(0, 0)}
        className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded-xl ${
          isHalfwayScrolled ? '' : 'hidden'
        }`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="h-6 w-6 mx-auto"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
        </svg>
      </button>
      <button
        onClick={() => window.scrollTo(0, document.body.scrollHeight)}
        className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded-xl ${
          isHalfwayScrolled ? 'hidden' : ''
        }`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="h-6 w-6 mx-auto"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
    </div>
  );
}
